/** @format */

import React, { FC, useState, useEffect } from 'react'
import useFormTable from 'src/hooks/useFormTable'
import TablePage from 'src/components/TablePage'
import { API, HandleDealPolicy } from 'src/api/ApiAlarmServer'
import { MonitorSearch, Divider } from 'src/components'
import CreateAlarmDrawer from 'src/containers/EventCenter/CreateAlarmDrawer'
import { eventListToOptions, EventOptions } from 'src/pages/EventCenter/constants'
import { _$, Button, Icon, Message, Tooltip, Switch } from 'kpc-react'
import { useHistory } from 'react-router'
import { request } from 'src/utils'
import { LabelValueItem } from 'src/utils/interface'
import styled from 'styled-components'
import variable from 'src/static/styles/var'
interface OwnProps {
  className?: string
  ref?: any
}
const AlarmEventList: FC<OwnProps> = ({ className }, ref) => {
  const [eventList, setEventList] = useState([])
  const [policyName, setPolicyName] = useState('')
  const [createAlarmVisible, setCreateAlarmVisible] = useState<boolean>(false)
  const [curAlarmData, setCurAlarmData] = useState({})
  const [productGroup, setProductGroup] = useState<LabelValueItem<string, number>[]>()
  const [tableGroup, setTableGroup] = useState({
    productName: 999
  })
  const [checkedTable, setCheckedTable] = useState<string[]>([])
  const history = useHistory()

  useEffect(() => {
    getEventList()
  }, [])
  // 获取所有事件
  const getEventList = async () => {
    const result = await request(API.GetListSysEvents, {
      data: {
        ProductType: 999
      }
    })
    if (result && result?.code === 'Success' && result?.data.eventList) {
      const eventList = result.data.eventList
      const filter = eventListToOptions(eventList) as EventOptions[]
      const map = filter?.map(item => ({
        label: item.label,
        value: item.value as number
      }))
      setProductGroup([{ label: _$('全部'), value: 999 }, ...map])
      return result
    } else {
      Message.error(result?.message)
      return null
    }
  }

  const { run, result, pageState, loading, total }: any = useFormTable(
    API.GetEventPolicy,
    {
      params: {
        ProductType: tableGroup.productName,
        PolicyName: policyName
      }
    },
    data => ({
      tableData: data?.policyList,
      totalCount: data?.totalCount
    })
  )
  const eventScheme = {
    policyName: {
      title: _$('策略名称')
    },
    productName: {
      title: _$('产品类型'),
      group: productGroup
    },
    policyPattern: {
      title: _$('告警规则'),
      template: function (item) {
        const { eventNamesDesc = [] } = item.policyPattern
        if (eventNamesDesc[0]?.nameDesc === '*') {
          return <p>{_$('全部事件')}</p>
        } else {
          return (
            <ul className="rule-list">
              {eventNamesDesc?.map(item => (
                <li key={item.name}>
                  <Tooltip content={_$(item?.nameDesc)}>
                    <span>{_$(item?.nameDesc)}</span>
                  </Tooltip>
                </li>
              ))}
            </ul>
          )
        }
      }
    },
    resouceBindType: {
      title: _$('关联资源'),
      template: function (item) {
        return (
          <span>
            {item.resourceBindType &&
            (item.resourceBindType === 2 || item.resourceBindType === 127) ? (
              <p>
                {_$('项目')}：{item.projectName || ''}
                {item.resourceBindType === 127 ? (
                  <span className="deleted_color">{_$('（已删除）')}</span>
                ) : null}
              </p>
            ) : null}
            <p>
              {_$('实例')}：{item.instanceCount || 0}
            </p>
          </span>
        )
      }
    },
    userNotice: {
      title: _$('告警接收人'),
      template: function (item) {
        const contactList = item.userNotice
        const group = contactList && [].concat(contactList).filter(i => i?.contactFlag === 1)
        const user = contactList && [].concat(contactList).filter(i => i?.contactFlag === 2)
        return (
          <span>
            {!contactList || !contactList?.length ? (
              <span>
                <Tooltip content={_$('未配置告警接收人将不会收到告警')}>{_$('未配置')}</Tooltip>
              </span>
            ) : (
              <>
                <span>
                  {_$('联系组')}：{group?.length}
                </span>
                <br />
                <span>
                  {_$('联系人')}：{user?.length}
                </span>
              </>
            )}
          </span>
        )
      }
    },
    enabled: {
      title: _$('状态'),
      template: function (item) {
        return (
          <Switch
            on={_$('启用')}
            off={_$('禁用')}
            width="62"
            value={item.enabled === 0}
            onClick={async () => {
              HandleDealEventPolicy(item.enabled === 0 ? 'disable' : 'enable', [item?.policyName])
            }}
          />
        )
      }
    },
    action: {
      title: '操作',
      template: function (item) {
        return (
          <div className="ksc-space">
            <a
              onClick={event =>
                history.push(`/monitor/alarmServer/history/detail/event/${item.policyName}`)
              }
            >
              {_$('告警历史')}
            </a>

            {item.resourceBindType !== 127 && (
              <>
                <Divider />
                <a
                  onClick={e => {
                    e.preventDefault()
                    setCreateAlarmVisible(true)
                    setCurAlarmData({
                      PolicyName: item.policyName,
                      PolicyDesc: item.policyDesc,
                      ProductType: item.productType,
                      ResourceBindType: item.resourceBindType,
                      InstanceGrpIds: item.instanceGrpIds,
                      ProjectId: item.projectId,
                      EventRadio: item.policyPattern?.eventNames[0] === '*' ? 1 : 2,
                      EventNames:
                        item.policyPattern?.eventNames[0] === '*'
                          ? []
                          : item.policyPattern.eventNames,
                      UserNotice: item.userNotice,
                      UrlNotice: item.urlNotice
                    })
                  }}
                >
                  {_$('修改')}
                </a>{' '}
              </>
            )}
            <Divider />
            <Tooltip
              confirm
              theme="light"
              共
              trigger="click"
              content={_$('确认删除当前事件？')}
              onOk={() => HandleDealEventPolicy('delete', [item?.policyName])}
            >
              <a>{_$('删除')}</a>
            </Tooltip>
          </div>
        )
      }
    }
  }
  useEffect(() => {
    if (result) {
      setEventList(result)
    }
  }, [result])

  // 接口处理policy name
  // type: 处理方式
  const HandleDealEventPolicy = async (type: string, policyNames: string[]) => {
    const paramsData = {
      PolicyNames: policyNames
    }
    const resData = await HandleDealPolicy({ method: type, data: paramsData })
    if (resData?.['code'] === 'Success') {
      run()
      if (type === 'delete') {
        Message.success(_$('删除成功'))
      } else if (type === 'disable') {
        Message.success(_$('禁用成功'))
      } else if (type === 'enable') {
        Message.success(_$('启用成功'))
      }
    } else {
      Message.warning(resData?.['message'])
    }
  }
  // type: 事件处理类型
  // policyName: 事件类型名称
  const delEventPolicy = (type: string) => {
    if (!checkedTable?.length) return
    HandleDealEventPolicy(type, checkedTable)
  }

  return (
    <div className={className}>
      <div className="header">
        <div className="header-left">
          <Button
            type="primary"
            onClick={() => {
              setCreateAlarmVisible(true)
            }}
          >
            <Icon className="ion-plus-round"></Icon>
            {_$('新建告警策略')}
          </Button>
          <Button onClick={() => delEventPolicy('disable')}>{_$('禁用')}</Button>
          <Button onClick={() => delEventPolicy('enable')}>{_$('启用')}</Button>
          <Button onClick={() => delEventPolicy('delete')}>{_$('删除')}</Button>
        </div>
        <div>
          <MonitorSearch
            value={policyName}
            placeholder={_$('输入告警策略名称')}
            onChange={value => {
              run({
                ProductType: tableGroup.productName,
                PolicyName: value,
                PageIndex: 1
              })
              setPolicyName(value)
            }}
          />
        </div>
      </div>
      <TablePage
        tableProps={{
          scheme: eventScheme,
          data: eventList,
          rowCheckable: false,
          resizable: true,
          rowKey: (value, index) => value.policyName,
          'on$change-checked': (_c, value) => {
            setCheckedTable(value)
          },
          group: tableGroup,
          'on$change-group': (_c, value) => {
            setTableGroup(value)
            run({
              PageIndex: 1,
              ProductType: value.productName,
              PolicyName: policyName
            })
          }
        }}
        pageProps={{ total, ...pageState }}
        loading={loading}
        run={run}
      ></TablePage>

      {/* 新建告警策略 */}
      <CreateAlarmDrawer
        defaultValues={curAlarmData}
        visible={createAlarmVisible}
        setVisible={visible => {
          setCreateAlarmVisible(visible)
          !visible && setCurAlarmData({})
        }}
        submitCallback={() => run()}
      />
    </div>
  )
}

export default styled(AlarmEventList)`
  .header {
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
    .header-left {
      & > * {
        margin-right: 8px;
      }
    }
  }
  .none-setting {
    cursor: pointer;
    color: ${variable.errorColor};
  }
  .k-table {
    p {
      margin-bottom: 0;
    }
    .rule-list {
      li {
        max-width: 100%;
        height: 18px;
        span {
          display: inline-block;
          max-width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
`
